import { render, staticRenderFns } from "./ViewRenuncia.html?vue&type=template&id=0af1d387&external"
import script from "./ViewRenuncia.vue?vue&type=script&lang=js"
export * from "./ViewRenuncia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports